module.exports = __webpack_public_path__ + "49216498.svg";